import { render } from "./ModalElectricitySwitchgear.vue?vue&type=template&id=afdd14aa&scoped=true"
import script from "./ModalElectricitySwitchgear.vue?vue&type=script&lang=js"
export * from "./ModalElectricitySwitchgear.vue?vue&type=script&lang=js"

import "./ModalElectricitySwitchgear.vue?vue&type=style&index=0&id=afdd14aa&lang=scss&scoped=true"
import "./ModalElectricitySwitchgear.vue?vue&type=style&index=1&id=afdd14aa&lang=scss"

import exportComponent from "/Users/dmytrokulyk/Documents/Development/GreenHub/dsp-f-2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-afdd14aa"]])

export default __exports__